{
  "title": "Motivational Speech",
  "source": "Acquisitions Inc.",
  "levelAndSchool": "3rd-level enchantment",
  "level": 3,
  "castingTime": "1 minute",
  "range": "60 feet",
  "components": "V",
  "duration": "1 hour",
  "description": [
    "Choose up to five creatures within range that can hear you. For the duration, each affected creature gains 5 temporary hit points and has advantage on Wisdom saving throws. If an affected creature is hit by an attack, it has advantage on the next attack roll it makes. Once an affected creature loses the temporary hit points granted by this spell, the spell ends for that creature.",
    "At Higher Levels: When you cast this spell using a spell slot of 4th level or higher, the temporary hit points increase by 5 for each slot level above 3rd.",
    "Spell Lists: Bard, Cleric"
  ],
  "spellLists": ["bard", "cleric"]
}
